module.exports = __webpack_public_path__ + "img/logo.fd4b2b0d.svg";